module.exports = __webpack_public_path__ + "static/media/_5216184-1-4-2.8eb16c6c.jpg";